import Moment from 'moment';
import { Log } from 'ng2-logger';
import React, { Dispatch } from 'react';
import { connect } from 'react-redux';
import { Common } from '../../../../core/common';
import Translator from '../../../../core/i18n';
import { IAction, IAppState } from '../../../../models/action/core';
import { ISignleActivityCard } from '../../../../models/components/single-activity-card';
import { getCourseContentsWeekActivitiesAction, SetUpdateInput } from '../../../../store/actions/coursePage';
import ProcessingActivity from '../activity-proccessing/processing-activity';
import { UserType } from '../../../../models/enums/userType';
import { SecurityContextType, SecurityPermissionType } from '../../../../core/SecurityContext';
import EdiText from 'react-editext';
import { Notification } from '../../../notification/main';
import PdfPreview from '../../../previews/pdf/main';
import Truncater from '../../../truncater/main';
import { Button } from '../../../ui-elements/main';

const T = Translator.create();
let _common: Common;

const _logger = Log.create('InformationNoteActivityCard');
const maxEditTextLength = 65;


class InformationNoteActivityCard extends React.Component<ISignleActivityCard> {
    public state = {
        activityCardImage: '', isPDFViewerModalOpen: false,
        editTextValue:
            this.props.activityCard!.name!.toString().length > maxEditTextLength
                ? this.props.activityCard!.name!.slice(0, maxEditTextLength).toString() + '...'
                : this.props.activityCard!.name!.toString(),
        editTextHandleValue: this.props.activityCard!.name!.toString(),
        selectedFile: { name: "", path: "" },
        isModalOpen: false
    };
    constructor(props: any) {
        super(props);
        _common = new Common();
        Moment.locale(T.i18next.language);
        this.afterSave = this.afterSave.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
    }

    public clickToDownloadHandle = (e: any) => {
        const filepath = e.currentTarget!.getAttribute('data-filepath').toString();
        const fileName = e.currentTarget!.getAttribute('data-filename').toString();
        if (filepath && fileName) {
            _common.DownloadLink(filepath + '/download', fileName);
        }
    };

    public clickToDownload = (fileName: any, filePath: any) => {
        if (filePath && fileName) {
            _common.DownloadLink(filePath + '/download', fileName);
        }
    };

    public arrayBufferToBase64(buffer: any) {
        let binary = '';
        const bytes = [].slice.call(new Uint8Array(buffer));

        bytes.forEach(b => (binary += String.fromCharCode(b)));

        return window.btoa(binary);
    }



    afterSave() {
        this.props.dispatch(getCourseContentsWeekActivitiesAction(
            this.props.coursePageClassId ? this.props.coursePageClassId : '0',
            this.props.coursePageActivityId ? this.props.coursePageActivityId : '0',
            this.props.weekOrUnitId === '0' ? false : true,
            0,
            1000,
            this.props.weekOrUnitId === '0' ? '-1' : this.props.weekOrUnitId!,
            false,
            false,
            null,
            'contentWeekActivities',
            'get', undefined, this.props.sortKey ?? "-"));
    }

    public handleSave = (name: any) => {
        if (this.props.activityCard && this.props.activityCard.activityId && this.props.activityCard.name !== name) {
            this.props.dispatch(
                SetUpdateInput(this.props.activityCard.activityId, name, 'api/activity/updateActivityName', 'POST', this.props.classId!, this.afterSave)
            );
            this.setState({
                editTextValue: name.length > maxEditTextLength
                    ? name.slice(0, maxEditTextLength).toString() + '...'
                    : name.toString(), editTextHandleValue: name
            });
        }
    };

    handleClick(pdfFileName: string) {
        this.setState({ editTextValue: pdfFileName });
        this.clickToDownloadHandle(pdfFileName);
    }

    handleKeyDown(e: any, pdfFileName: string) {
        if (e.key === 'Enter' || e.key === ' ') {
            this.setState({ editTextValue: pdfFileName });
            this.clickToDownloadHandle(pdfFileName);
        }
    }
    handleCancel = () => {
        const { editTextValue } = this.state;
        const truncatedValue = editTextValue.length > maxEditTextLength
            ? editTextValue.slice(0, maxEditTextLength) + '...'
            : editTextValue;
        this.handleClick(truncatedValue);
    };

    viewAttachmentTitle = (activityCard: any, pdf: any) => {
        let returnValue: any = '';

        if (activityCard.file && activityCard.file.length) {
            const filterValue = activityCard.file.filter((file: any) => !pdf || file.fileId !== pdf.fileId);

            if (filterValue.length > 0) {
                returnValue = <span className="upload-title" tabIndex={0}>{T.t('r_activity_attachments2')}</span>;
            }
        }

        return returnValue;
    }


    public clickToView = async (e: any) => {
        const filepath = e.currentTarget!.getAttribute('data-filepath').toString();
        const fileName = e.currentTarget!.getAttribute('data-filename').toString();

        if (filepath && fileName) {
            this.setState({ selectedFile: { name: fileName, path: filepath }, isModalOpen: true })
        } else {
            Notification.setNotification('error', T.t('r_fileUpload_error'), 'topRight');
        }
    };

    setClosePrivewModal = () => {
        this.setState({ selectedFilePath: {}, isModalOpen: false })
    }

    public render() {
        let isCompletedPrerequisiteActivity: boolean = false;
        const isStudent = this.props.userType === UserType.Student;
        const activityCard = this.props.activityCard;
        const prerequisiteActivityId = activityCard ? activityCard.prerequisiteActivityId : null;


        if (isStudent && prerequisiteActivityId) {
            const enrollmentStatus = this.props.enrollmentData?.find(enrollment => enrollment.activityId === prerequisiteActivityId)?.status ?? 0;
            isCompletedPrerequisiteActivity = enrollmentStatus === 2;
        }

        const pdf = this.props.activityCard?.file?.find(file => file.extension === '.pdf');

        const cardClass = this.props.activityCard?.activeStatus === 0 ? 'card new-activity border-pasif' : 'card new-activity';
        const hasPermissionToAddActivity = Common.HasPermission(SecurityContextType.Class, SecurityPermissionType.Activity_Add, this.props.classId!);

        return activityCard ? (
            <div className="col-12 mobile-padding card-width">
                <div className={cardClass}>
                    <div className="card-header">
                        <div className={"activity-title " + (!_common.isArabic(this.state.editTextValue, document.body.getAttribute('dir')) ? 'arabic-text-card' : '')}>
                            <img
                                src={_common.GetActivityTypeIcons('informationnote')}
                                alt="Information Note Activity Icon"
                            />
                            <div title={activityCard.name} className="visible">
                                {hasPermissionToAddActivity ? (
                                    <EdiText
                                        type="text"
                                        onSave={this.handleSave}
                                        onCancel={this.handleCancel}
                                        onEditingStart={() => this.handleClick(this.state.editTextHandleValue)}
                                        value={this.state.editTextValue}
                                        showButtonsOnHover={true}
                                        saveButtonClassName="hideEditextSaveButton"
                                        cancelButtonClassName="hideEditextCancelButton"
                                        validationMessage={T.t('r_forum_tree_character')}
                                        validation={val => val.trim().length >= 3}
                                        editOnViewClick={true}
                                        submitOnEnter={true}
                                        cancelOnEscape={true}
                                        className={"font-weight-bold mobile-activity-title web-activity-title" + (!_common.isArabic(this.state.editTextValue, document.body.getAttribute('dir')) ? ' arabic-text-direction' : '')}
                                        tabIndex={0}
                                    />
                                ) : (
                                    <div title={activityCard.name} className={"mobile-activity-title web-activity-title" + (!_common.isArabic(this.state.editTextValue, document.body.getAttribute('dir')) ? ' arabic-text-direction' : '')} style={{ cursor: 'pointer', lineHeight: 1.3, whiteSpace: 'pre-line', textOverflow: 'ellipsis' }}>
                                         {activityCard.name && <Truncater length={42} text={activityCard.name}></Truncater>}
                                    </div>
                                )}
                            </div>

                            <ProcessingActivity
                                externalCssClassName="show_on_mobile"
                                activityId={activityCard.activityId}
                                activityType={activityCard.activityType}
                            />
                        </div>
                        <div className="activity-status">
                            {activityCard.alwaysOnTop && <span className="pinned"></span>}
                            <span className="badges badges-informationnote activity-type" tabIndex={0}>{T.t('r_activity_type_InformationNote')}</span>
                            <ProcessingActivity
                                externalCssClassName="hide_on_mobile"
                                activityId={activityCard.activityId}
                                activityType={activityCard.activityType}
                            />
                        </div>
                    </div>
                    {(activityCard.description && (isCompletedPrerequisiteActivity || !prerequisiteActivityId || !isStudent)) && (
                        <hr className="bottom-border-2 mobile-not-show" />
                    )}
                    <div className="card-body">
                        {(activityCard.description && (isCompletedPrerequisiteActivity || !prerequisiteActivityId || !isStudent)) && (
                            <div className={"row mobile-activity-information-description px-4" + (!_common.isArabic(activityCard.description, document.body.getAttribute('dir')) ? ' arabic-text-direction' : '')} tabIndex={0} >
                                <pre dangerouslySetInnerHTML={{ __html: activityCard.description }} />
                            </div>
                        )}
                        {activityCard.file && <hr style={{ marginLeft: 0, marginRight: 0 }} className="bottom-border-2 mobile-not-show" />}
                        {!isCompletedPrerequisiteActivity && prerequisiteActivityId && isStudent && (
                            <div className='row' style={{
                                opacity: 0.5, flexDirection: 'column',
                                fontSize: '1em !important',

                                alignItems: 'center',
                                justifyContent: 'center',
                                textAlign: 'center',
                            }}>
                                <i className="material-icons" style={{ fontSize: '96px', marginTop: '10px' }}>lock</i>
                                <h5 className="font-medium">
                                    {T.t('r_activity_restriction_by_another_message').replace('{0}', activityCard.name).replace('{1}', activityCard.prerequisiteActivityName)}
                                </h5>
                            </div>
                        )}

                        {(isCompletedPrerequisiteActivity || !prerequisiteActivityId || !isStudent) && pdf && (
                            <div className="row file-upload-section" style={{ marginLeft: 0, marginRight: '-5px' }}>

                                {activityCard.file && activityCard.file.length > 0 && (
                                    <span className="upload-title" tabIndex={0}>{T.t('r_activity_attachments2')}</span>
                                )}

                                <div className="upload-file-temp">

                                    <button
                                        onClick={() => this.clickToDownload(pdf.fileName, pdf.filePath)}
                                        style={{ cursor: "pointer", border: 'none', background: 'none', textAlign: 'start' }}
                                        className="upload-file-name mobile-files web-files"
                                    >
                                        <img src={_common.GetDefaultIcons('blueattach')} className="ml-1 mr-3" alt="" />
                                        <span>{pdf.fileName}</span>
                                    </button>


                                    <div className="upload-desc d-flex justify-content-end gap-1">
                                        <Button
                                            button_type='secondary'
                                            size='small'
                                            text={T.t('r_download')}
                                            data-filename={pdf?.fileName}
                                            data-filepath={pdf?.filePath}
                                            iconPosition='left'
                                            materialicon='cloud_download'
                                            onClick={() => this.clickToDownload(pdf?.fileName, pdf?.filePath)}
                                        />
                                        {pdf.contentType == "application/pdf" &&

                                             <Button
                                             button_type='secondary'
                                             size='small'
                                             text={T.t('r_preview')}
                                             data-filename={pdf?.fileName}
                                             data-filepath={pdf?.filePath}
                                             iconPosition='left'
                                             materialicon='visibility'
                                             onClick={() => this.clickToView({
                                                 currentTarget: {
                                                     getAttribute: (attr: string) => attr === 'data-filepath' ? pdf?.filePath : pdf?.fileName
                                                 }
                                             })}
                                             />
                                        }
                                    </div>
                                </div>
                            </div>
                        )}
                        {((isCompletedPrerequisiteActivity || !prerequisiteActivityId || !isStudent) && activityCard.file?.length! > 0) && (
                            <div className="row file-upload-section" style={{ marginLeft: 0, marginRight: '-5px' }}>

                                {this.viewAttachmentTitle(activityCard, pdf)}

                                {activityCard.file?.filter(file => !pdf || file.fileId !== pdf.fileId).map((file, fileIndex) => (
                                    <div className="upload-file-temp" key={fileIndex}>
                                        <button
                                            style={{ cursor: 'pointer', lineHeight: 1.3, overflow: 'hidden', whiteSpace: 'pre-line', textOverflow: 'ellipsis', border: 'none', background: 'none', textAlign: 'start', width: "100%" }}
                                            data-filename={file?.fileName}
                                            data-filepath={file?.filePath}
                                            onClick={() => this.clickToDownload(file?.fileName, file?.filePath)}
                                            onKeyDown={(e) => this.handleKeyDown(e, file?.fileName!)}
                                            className="upload-file-name mobile-files web-files"
                                            title={file.fileName}
                                            tabIndex={0}
                                        >
                                            <img src={_common.GetDefaultIcons('blueattach')} className="mx-3" alt="" />
                                            <span>{file.fileName}</span>
                                        </button>

                                        <div className="upload-desc d-flex justify-content-end gap-1">
                                            <Button
                                                button_type='secondary'
                                                size='small'
                                                text={T.t('r_download')}
                                                data-filename={file?.fileName}
                                                data-filepath={file?.filePath}
                                                iconPosition='left'
                                                materialicon='cloud_download'
                                                onClick={() => this.clickToDownload(file?.fileName, file?.filePath)}
                                            />
                                            {file.contentType == "application/pdf" &&

                                                    <Button
                                                    button_type='secondary'
                                                    size='small'
                                                    text={T.t('r_preview')}
                                                    data-filename={file?.fileName}
                                                    data-filepath={file?.filePath}
                                                    iconPosition='left'
                                                    materialicon='visibility'
                                                    onClick={() => this.clickToView({
                                                        currentTarget: {
                                                            getAttribute: (attr: string) => attr === 'data-filepath' ? file?.filePath : file?.fileName
                                                        }
                                                    })}
                                                    />
                                            }
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}


                    </div>
                    <PdfPreview
                        modalIsOpen={this.state.isModalOpen}
                        selectedFile={this.state.selectedFile}
                        setCloseModal={this.setClosePrivewModal}
                    />
                </div>
            </div>
        ) : (
            <h4>{T.t('r_activity_was_not_found')}</h4>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: ISignleActivityCard): ISignleActivityCard => {
    if (!state) {
        return ownProps;
    }

    const newProps: ISignleActivityCard = Object.assign({}, ownProps, {
        userType: state.login.identitiy.userType,
        userPreferences: state.profile.userPreferences.preferences,
        coursePageClassId: state.coursePage.coursePageClassId,
        weekOrUnitId: state.coursePage.weekOrUnitId,
        enrollmentData: state.enrollment.enrollmentData,
        courseContentWeeksActivities: state.coursePage.courseContentWeekActivities,
        coursePageActivityId: state.coursePage.coursePageActivityId,
        sortKey: state.coursePage.courseSortingKey
    });
    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret = (
        next.coursePage.coursePageActivityId === prev.coursePage.coursePageActivityId &&
        next.coursePage.coursePageClassId === prev.coursePage.coursePageClassId &&
        next.coursePage.courseSortingKey === prev.coursePage.courseSortingKey &&
        next.enrollment.enrollmentData === prev.enrollment.enrollmentData &&
        next.login.identitiy.userType === prev.login.identitiy.userType &&
        next.coursePage.weekOrUnitId === prev.coursePage.weekOrUnitId &&
        next.coursePage.courseContentWeekActivities === prev.coursePage.courseContentWeekActivities

    );
    return ret;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const CInformationNoteActivityCard = connect(
    mapStateToProps,
    dispatchProps, null, { areStatesEqual }
)(InformationNoteActivityCard);

export default CInformationNoteActivityCard;
